import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { WHATSAPP_NUMBER } from '../config/clientPortalConstants';
import '../styles/ClientLayout.css';

const HOST_ME_LOGO = process.env.PUBLIC_URL + '/images/Host Me logo 2.png';

/**
 * ClientLayout — shared shell for the client portal multi-page app.
 * Provides header (logo + greeting), bottom tab nav, and WhatsApp FAB.
 *
 * Does NOT fetch data — receives clientName and clientEmail as props.
 * Does NOT handle loading/error states — pages handle those full-page.
 *
 * Usage:
 *   <ClientLayout activeTab="home" clientName={data.clientName}>
 *     {page content}
 *   </ClientLayout>
 *
 * Follows manual layout wrapping pattern (same as DesktopLayout/PublicLayout).
 * See CLEANING_SERVICE_ARCHITECTURE.md → Client Portal Architecture Decisions.
 */
const ClientLayout = ({ children, activeTab, clientName, clientEmail, onEditName }) => {
  const { token } = useParams();
  const location = useLocation();

  const tabs = [
    { id: 'home', label: 'الرئيسية', icon: 'bi-house-door', to: `/client/t/${token}` },
    { id: 'visits', label: 'سجل الزيارات', icon: 'bi-clock-history', to: `/client/t/${token}/visits` },
    { id: 'locations', label: 'مواقعي', icon: 'bi-geo-alt', to: `/client/t/${token}/locations` },
  ];

  return (
    <div className="cd-layout">
      {/* Header */}
      <div className="cd-layout__header">
        <img src={HOST_ME_LOGO} alt="Host Me" className="cd-layout__logo" />
        <div className="cd-layout__header-info">
          <h1
            className="cd-layout__greeting"
            onClick={onEditName || undefined}
            style={onEditName ? { cursor: 'pointer' } : undefined}
          >
            {clientName ? `مرحباً ${clientName}` : '\u00A0'}
            {onEditName && <i className="bi bi-pencil cd-layout__edit-icon" />}
          </h1>
          {clientEmail && (
            <span className="cd-layout__email">{clientEmail}</span>
          )}
        </div>
      </div>

      {/* Page Content */}
      <div className="cd-layout__content">
        {children}
      </div>

      {/* Bottom Tab Navigation */}
      <nav className="cd-nav">
        {tabs.map(tab => {
          const isActive = tab.id === activeTab;
          const isDisabled = false; // All tabs now have pages

          if (isDisabled) {
            return (
              <button
                key={tab.id}
                className="cd-nav__tab cd-nav__tab--disabled"
                type="button"
                disabled
              >
                <i className={`bi ${tab.icon}`} />
                <span>{tab.label}</span>
                <span className="cd-nav__soon">قريباً</span>
              </button>
            );
          }

          return (
            <Link
              key={tab.id}
              to={tab.to}
              className={`cd-nav__tab touch-target-disabled${isActive ? ' cd-nav__tab--active' : ''}`}
            >
              <i className={`bi ${tab.icon}`} />
              <span>{tab.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* WhatsApp FAB */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}`}
        className="cd-layout__wa-fab"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="bi bi-whatsapp" />
      </a>
    </div>
  );
};

export default ClientLayout;
